import React, { useCallback }  from 'react';
import { View, Image, Text, ScrollView } from 'react-native';
import { detailsStyles } from '../styles/details';
import { extraStyles } from '../styles/extra';
import BouncyCheckbox from 'react-native-bouncy-checkbox';
import { useDispatch, useSelector } from 'react-redux';
import { addItem } from '../../Redux/actions';
import CartBtn from './CartBtn';


export const extras = [
  {
    image: require('../../assets/chips.png'),
    name: 'Chips',
    quantity: '(250g)',
    price: 100,
  },
  {
    image: require('../../assets/juice.png'),
    name: 'Juice',
    quantity: '(300ml)',
    price: 100,
  },
  {
    image: require('../../assets/shawarama.png'),
    name: 'Shawarma',
    quantity: '(250g)',
    price: 350,
  },
  {
    image: require('../../assets/olive.png'),
    name: 'Olive',
    quantity: '(50g)',
    price: 100,
  },
  {
    image: require('../../assets/burger2.png'),
    name: 'Burger',
    quantity: '(250g)',
    price: 350,
  },
  {
    image: require('../../assets/sandwich.png'),
    name: 'Sandwich',
    quantity: '(250g)',
    price: 350,
  },
  {
    image: require('../../assets/veggie.jpg'),
    name: 'Salad',
    quantity: '(250g)',
    price: 200,
  },
]


const Extra = () => {
  const dispatch = useDispatch();
  const selectedItems = useSelector((state) => state.selectedItems);

 const handleItemSelection = useCallback(
   (item) => {
     dispatch(addItem(item));
   },
   [dispatch],
 );

  return (
    <>
      <View style={detailsStyles.detailWrapper}>
        <Text style={extraStyles.extraTitle}>Add</Text>

        <ScrollView vertical showsVerticalScrollIndicator={false}>
          {extras.map((extra, index) => (
            <View style={extraStyles.extraWrapper} key={index}>
              <View style={extraStyles.extraLeft}>
                <Image source={extra.image} style={extraStyles.extraPic} />
                <View>
                  <Text style={extraStyles.extraname}>{extra.name}</Text>
                  <Text style={extraStyles.extraname2}>{extra.quantity}</Text>
                </View>
              </View>
              <View style={extraStyles.priceWrapper}>
                <Text style={extraStyles.extraprice}>Ksh.{extra.price}</Text>
              </View>
              <BouncyCheckbox
                size={20}
                fillColor="#32de84"
                innerIconStyle={{ borderWidth: 2, borderColor: '#A9A9A9' }}
                onPress={() => handleItemSelection(extra)}
              />
            </View>
          ))}
        </ScrollView>

        <CartBtn/>
      </View>
    </>
  );
};

export default Extra;

